export default "__VITE_ASSET__BS6ug8V3__"